export default "__VITE_ASSET__DjXORZc0__"